import React, { useEffect } from "react";
import Home from "./Home";
import Memo from "./memo";
import Share from "./Share";
import EditMemo from "./Edit_memo";
import Exame from "./Exame";
import { Routes, Route } from "react-router-dom";
import left from "../img/left.png";
import right from "../img/right.png";
import "../style/container.css";

const Conteiner = () => {
  useEffect(() => {
    window.onresize = () => {
      if (window.innerWidth < 1130) {
        document.querySelector(".left").style = "display:none !important;";
        document.querySelector(".right").style = "display:none !important;";
      } else {
        document.querySelector(".left").style = "display:grid !important;";
        document.querySelector(".right").style = "display:grid !important;";
      }
    };
    window.onload = () => {
      if (window.innerWidth < 1130) {
        document.querySelector(".left").style = "display:none !important;";
        document.querySelector(".right").style = "display:none !important;";
      } else {
        document.querySelector(".left").style = "display:grid !important;";
        document.querySelector(".right").style = "display:grid !important;";
      }
    };
  }, []);

  return (
    <div className="container">
      <div className="left">
        <img draggable="false" src={left} alt="" />
      </div>
      <Routes>
        <Route index element={<Home />} />
        <Route path="/memo" element={<Memo />} />
        <Route path="/edit_memo" element={<EditMemo />} />
        <Route path="/share/:id" element={<Share />} />
        <Route path="/exame" element={<Exame />} />
      </Routes>
      <div className="right">
        <img draggable="false" src={right} alt="" />
      </div>
    </div>
  );
};
export default Conteiner;
